import React from 'react';
import {graphql} from 'react-apollo';
import { Spinner, Message } from 'dab-component-lib';
import {basicPage} from '../../queries';
import I18n from '../../I18n/I18n';

import { GridContainerStyle, LoadingStyle, ErrorStyle } from '../../utils/style-utils';
import { CookiesStyle } from './style';

class Cookies extends React.Component {

  render() {
    const {basicPage: {loading, error, pagebytypeGraphql1View}} = this.props;

    if (loading) {
      return (
        <LoadingStyle>
          <Spinner size={150}/>
        </LoadingStyle>
      );
    }

    if (error || (!loading && !error && !pagebytypeGraphql1View.results.length > 0)) {
      return (
        <ErrorStyle>
          <Message title={I18n.t('errors.pageLoadingError')}/>
        </ErrorStyle>
      );
    }

    return (
      <GridContainerStyle>
        <CookiesStyle>
          <div dangerouslySetInnerHTML={{__html:
            pagebytypeGraphql1View.results[0].body.processed}}></div>
        </CookiesStyle>
      </GridContainerStyle>
    );
  }
}

export default graphql(
  basicPage, {
    name: 'basicPage',
    options: props => ({
      variables: {
        type: "0"
      }
    })
  }
)(Cookies);


// WEBPACK FOOTER //
// ./src/components/cookies/index.js